// Shared localStorage keys for lead-generation coupon auto-apply.
// (The first-visit signup popup was removed; these keys remain for pending codes.)
export const PENDING_DISCOUNT_CODE_KEY = "pendingDiscountCode";
export const HAS_APPLIED_INKSOFT_COUPON_KEY = "hasAppliedInksoftCoupon";

export function getLocalStorageValue(key: string): string | null {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function setLocalStorageValue(key: string, value: string): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // No-op when storage is blocked by browser settings.
  }
}

export function removeLocalStorageValue(key: string): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(key);
  } catch {
    // No-op when storage is blocked by browser settings.
  }
}
